
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"1200","height":"600"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0 0v150h700v150H600zm0 300v100h300V0h300z"}})]),_c('path',{attrs:{"id":"a","fill":"#ffce00","d":"M0-50.08l29.437 90.596-77.067-55.992h95.26l-77.067 55.993z"}}),_c('use',{attrs:{"id":"c","xlink:href":"#a","transform":"rotate(36)"}})]),_c('path',{attrs:{"fill":"#00247d","d":"M0 0h1200v600H0z"}}),_c('path',{attrs:{"d":"M0 0l600 300M0 300L600 0","stroke":"#fff","stroke-width":"60"}}),_c('path',{attrs:{"d":"M0 0l600 300M0 300L600 0","stroke":"#cf142b","stroke-width":"40","clip-path":"url(#b)"}}),_c('path',{attrs:{"d":"M300 0v400M0 150h700","stroke":"#fff","stroke-width":"100"}}),_c('path',{attrs:{"d":"M300 0v400M0 150h700","stroke":"#cf142b","stroke-width":"60"}}),_c('path',{attrs:{"d":"M0 300h600V0h600v600H0z","fill":"#5b97b1"}}),_c('use',{attrs:{"xlink:href":"#a","x":"645.34","y":"540.994"}}),_c('use',{attrs:{"xlink:href":"#c","x":"788.026","y":"504.516"}}),_c('use',{attrs:{"xlink:href":"#c","x":"788.026","y":"382.532"}}),_c('use',{attrs:{"xlink:href":"#c","x":"914.03","y":"473.684"}}),_c('use',{attrs:{"xlink:href":"#c","x":"914.03","y":"208.271"}}),_c('use',{attrs:{"xlink:href":"#a","x":"996.442","y":"390.046"}}),_c('use',{attrs:{"xlink:href":"#c","x":"1019.928","y":"172.078"}}),_c('use',{attrs:{"xlink:href":"#a","x":"1102.836","y":"321.554"}}),_c('use',{attrs:{"xlink:href":"#a","x":"1102.836","y":"87.486"}})])
          )
        }
      }
    